import { FieldSchemaType } from 'lib/fields';

// todo(danielaraujo): add support for Hash
export const SUPPORTED_FIELD_TYPE: FieldSchemaType[] = [
  FieldSchemaType.Array,
  FieldSchemaType.Boolean,
  FieldSchemaType.Integer,
  FieldSchemaType.Number,
  FieldSchemaType.String,
];
